export default "__VITE_ASSET__Fva66JRk__"